import { useLayoutEffect } from 'react';
export var MINDSET_HIDE_AGENT_DOCK_EVENT = 'mindset:hide-agent-dock';
export var MINDSET_SHOW_AGENT_DOCK_EVENT = 'mindset:show-agent-dock';
var hideRequestCount = 0;
export function isMindsetAgentDockHidden() {
  return hideRequestCount > 0;
}

/**
 * useHideMindsetAgentDock
 * Hides MindsetAgentDock (sidebar or floating variant) while `enabled` is true —
 * for pages/components that embed their own Mindset agent instead (e.g.
 * MindsetAgentCard), to avoid two simultaneous agent instances.
 * Uses useLayoutEffect rather than useEffect so the hide signal lands before
 * MindsetAgentDock's first paint or auto-init effect.
 * @param enabled - Set false to skip claiming the hide lock.
 */
export function useHideMindsetAgentDock() {
  var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  useLayoutEffect(function () {
    if (typeof window === 'undefined' || !enabled) return;
    hideRequestCount += 1;
    if (hideRequestCount === 1) {
      window.dispatchEvent(new CustomEvent(MINDSET_HIDE_AGENT_DOCK_EVENT));
    }
    return function () {
      hideRequestCount = Math.max(0, hideRequestCount - 1);
      if (hideRequestCount === 0) {
        window.dispatchEvent(new CustomEvent(MINDSET_SHOW_AGENT_DOCK_EVENT));
      }
    };
  }, [enabled]);
}